export const DEFINITION_POOL_ADD = 'serviceData.DEFINITION_POOL_ADD';
export const DEFINITION_POOL_ADD_COMMIT = 'serviceData.DEFINITION_POOL_ADD_COMMIT';
